module.exports = __webpack_public_path__ + "static/media/play.dd8fc8a6.svg";